import { useTranslation } from "react-i18next";
import { Modal } from "../Modal";
import { ReactiveFormSMSelect } from "../form/ReactiveFormSMSelect";
import { useForm } from "react-hook-form";
import { ArrowsRightLeftIcon } from "@heroicons/react/24/outline";
import { SmallModal } from "../SmallModal";
import { Client } from "../../models/Client";
import { reAssignClientAgent } from "../../state/clients/actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../state/store";
import { useEffect, useState } from "react";
import { Toast } from "../Toast";
import { toast, ToastContainer } from "react-toastify";
import { LoadingMask } from "../LoadingMask";

interface Props {
    info: {
        show: boolean;
        agents?: any;
        client: Client | null
    };
    onSubmited: (client: Client) => void;
    onClose: () => void;
}

export const ClientReAssignAgentModal: React.FC<Props> = ({
    info,
    onSubmited,
    onClose
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const isLoading = useSelector((state: RootState) => state.clients.isLoading);
    const error = useSelector((state: any) => state.clients.error);
    const [showReAssignAgentError, setShowReAssignAgentError] = useState(false);

    useEffect(() => {
        if (showReAssignAgentError) {
          Toast(t(error?.reason ?? "SOMETHING_WENT_WRONG"), t(error?.cause_info));
        }
    }, [showReAssignAgentError, error, t]);

    const methods = useForm<any>({
            defaultValues: {}
    })
    const { handleSubmit, control, reset } = methods;

    const onSubmit = (data: any) => {
        console.log(data);
        if(data.agent && info.client !== null) {
            dispatch(reAssignClientAgent({ clientId: info.client.id!, agentId: data.agent })).then((e) => {
                if (e.type === "clients/reAssignClientAgen/rejected") {
                    setShowReAssignAgentError(true);
                } else {
                    let client = (e.payload || {}) as Client;
                    toast(t("SUCCESSFULLY_REASSING_CLIENT_AGENT"));
                    onSubmited(client)
                    closeModal();
                }
            });
        }
    }
    
    const closeModal = () => {
        reset({});
        onClose();
    };

    return (<>
        <SmallModal
            isOpen={info.show}
            onClose={closeModal}
            label={t("ASSIGN_CLIENT_TITLE")}
            saveButton={{
                label: t("ASSIGN"),
                icon: <ArrowsRightLeftIcon />,
                onClick: handleSubmit(onSubmit),
            }}
        >
            <div className="w-full pt-3 pb-5">
                <div className={"w-full px-3"}>
                    <ReactiveFormSMSelect
                        isMulti={false}
                        selectClassName={"basic-single mb-3"}
                        name="agent"
                        label={t("AGENT_OF_RECORD")}
                        control={control}
                        options={info.agents}
                        menuPosition={"fixed"}
                        placeholder={"Select agent"}
                    />
                    <label className="text-gray-600 text-xs mb-5">
                        {t("ASSIGN_CLIENT_MESSAGE")}
                    </label>
                </div>
            </div>
        </SmallModal>
        <ToastContainer progressStyle={{ background: "#D4AF37" }} />
        {isLoading && <LoadingMask />}
    </>)
}